import type { FilterState } from '@/components/all-from-router/_components/deal-filters/types';
import { useUser } from '@/hooks/use-user';

const useMyDealsFilter = (): FilterState | null => {
  const user = useUser();
  const { role } = user;

  if (role === 'finance_manager') {
    return {
      filterMetaState: {
        type: 'finance_manager',
        position: 0,
        isNegated: false,
        isCurrentlyBeingBuilt: false,
      },
      selectedFilters: {
        [user.id]: true,
      },
    };
  }

  if (role === 'sales_rep') {
    return {
      filterMetaState: {
        type: 'sales_rep',
        position: 0,
        isNegated: false,
        isCurrentlyBeingBuilt: true,
      },
      selectedFilters: {
        [user.id]: true,
      },
    };
  }

  return null;
};

export default useMyDealsFilter;
